import cx from 'clsx';
import type { ReactNode } from 'react';
import React from 'react';
import { Pagination } from '@itandi/itandi-bb-ui';
import Styles from './CompanySettingList.module.scss';
import { useCompanySettings } from '~/hooks/vendors/useCompanySettings';
import type { CompanySettingWithItemSetting } from '~/models/CompanySetting';
import { CompanySettingListRow } from './CompanySettingListRow';
import { SearchInput } from '~/components/common/parts/search/SearchInput';

export const CompanySettingList: React.FC = () => {
  const [searchText, setSearchText] = React.useState<string>('');
  const [pageNum, setPageNum] = React.useState<number>(1);
  const { data } = useCompanySettings().index(searchText, pageNum);
  const searchInputRef = React.useRef(null);
  const handleChangeSearchText = React.useCallback(
    (searchWord: string) => {
      setSearchText(searchWord);
      setPageNum(1);
    },
    [setSearchText]
  );
  const handleChangePage = React.useCallback(
    (newPageNumber: number) => {
      setPageNum(newPageNumber);
    },
    [setPageNum]
  );
  const renderRow = React.useCallback(
    (companySetting: CompanySettingWithItemSetting): ReactNode => (
      <CompanySettingListRow
        key={companySetting.companyMasterId}
        companySetting={companySetting}
      />
    ),
    []
  );
  return (
    <div>
      <div className={Styles.TableTopArea}>
        <div className={Styles.SearchArea}>
          <SearchInput
            ref={searchInputRef}
            handleChange={handleChangeSearchText}
            placeholder="管理会社名で検索"
          />
        </div>
      </div>
      <table className={Styles.List}>
        <thead>
          <tr className={cx(Styles.ListRow, Styles.Header)}>
            <th>管理会社</th>
            <th>設定</th>
            <th>単価</th>
          </tr>
        </thead>
        <tbody>{data !== null && data.objects.map(renderRow)}</tbody>
      </table>
      {data !== null && (
        <div className={Styles.PaginationArea}>
          <Pagination
            currentPageNum={pageNum}
            maxPageNum={data.sumPageCount}
            onPageChange={handleChangePage}
          />
        </div>
      )}
    </div>
  );
};
